/**
 * Resolve tour step definitions to runtime steps, filtered by role.
 *
 * Step shape: { selector, placement, copy, roles?, requiresRoleSettingsAccess? }
 * roles: optional allow-list (e.g. ["Admin", "Manager"]); omit = all roles.
 */
export function resolveTourStepsForRole(
  steps,
  role,
  { canAccessRoleSettings = false } = {}
) {
  if (!role || !Array.isArray(steps)) return [];

  return steps
    .filter((step) => {
      if (step.roles && !step.roles.includes(role)) return false;
      if (step.requiresRoleSettingsAccess && !canAccessRoleSettings) return false;
      return true;
    })
    .map((step) => {
      const roleCopy = step.copy[role] || step.copy["Sales Rep"];
      return {
        selector: step.selector,
        placement: step.placement,
        title: roleCopy?.title ?? "",
        content: roleCopy?.content ?? "",
      };
    });
}
